type product = {
	name: string;
	price: number;
	description: string;
	detailedDescription: string;
	id: number;
	photo: string;
}[];

const products: product = [
	{
		name: 'MacBook Air Apple ',
		price: 1050,
		description: `Gold, 13.3"`,
		detailedDescription:
			'13.3-inch (diagonal) LED-backlit display with IPS technology; 2560-by-1600 native resolution at 227 pixels per inch with support for millions of colors',
		id: 1,
		photo: 'https://i.ibb.co/9TPfv4j/apple-macbook-air-133-zloty-1.jpg',
	},
	{
		name: 'Apple Watch',
		price: 800,
		description: 'Starlight Aluminum Case with Solo Loop',
		detailedDescription:
			'The aluminum case is lightweight and made from 100 percent recycled aerospace-grade alloy. The Solo Loop is made from soft, stretchable silicone and designed for ultracomfort with no clasps or buckles. ',
		id: 2,
		photo:
			'https://i.ibb.co/xM76rK9/MPL73-VW-34-FR-watch-41-alum-starlight-nc-8s-VW-34-FR-WF-SI.jpg',
	},
	{
		name: 'Xiaomi Redmi 10A',
		price: 4200,
		description: '32 or 64 GB internal storage and dedicated MicroSD slot',
		detailedDescription:
			'Xiaomi Redmi 10A comes with 6.53 inches HD+ screen. It has a Full-View waterdrop notch design. The back camera is of single 13 MP with autofocus, LED flash, HDR, f/2.2 aperture etc. features and Full HD video recording. The front camera is of 5 MP. ',
		id: 3,
		photo: 'https://i.ibb.co/n3dVwHX/Xiaomi-Redmi-10-A.jpg',
	},
	{
		name: 'Adidas Superstar Athletic Shoe',
		price: 500,
		description: ' Black / White',
		detailedDescription:
			'Step into the spotlight with the Superstar Sneakers from adidas! This basketball-inspired sneaker rocks a durable leather upper with classic rubber shell-toe and signature 3-Stripes detail on the side. ',
		id: 4,
		photo: 'https://i.ibb.co/5WN9qtD/istockphoto-458068097-612x612.jpg',
	},
	{
		name: 'Electric guitar',
		price: 7000,
		description: 'Light green electric guitar',
		detailedDescription: 'zxxcwuedhngfiusdhgfo',
		id: 5,
		photo: 'https://i.ibb.co/LNVrgzM/preview.jpg',
	},
	{
		name: 'Christmas cup',
		price: 20,
		description: 'Red Christmas cup ready for your coffee or tea',
		detailedDescription:
			'Christmas cup made of glass with lovely pattern, perfect for a Christmas gift',
		id: 6,
		photo: 'https://i.ibb.co/mB1dftg/images.jpg',
	},
	{
		name: 'Forest Candle',
		price: 10,
		description: 'Forest scented candle',
		detailedDescription:
			'You can feel like you are in the middle of the forest when you smell that candle',
		id: 7,
		photo: 'https://i.ibb.co/3hLvVL9/download.jpg',
	},
	{
		name: `Rubik's cube`,
		price: 30,
		description: 'MoYu RS3 M 2020',
		detailedDescription: `The MoYu RS3 M 2020 is a great mix of speed and stability, with a very responsive feel. I've found that setting up the cube to be relatively fast makes it much easier to learn and execute new finger tricks! `,
		id: 8,
		photo: 'https://i.ibb.co/CWCb5VK/MOYURS3-M2020-1024x1024.webp',
	},
	{
		name: 'Yosemite Valley Puzzle',
		price: 20,
		description: '1000 pieces',
		detailedDescription: `Imagine the gigantic glaciers and forces of nature that helped form the majestic “Yosemite Valley” as you puzzle this breathtaking scene!`,
		id: 9,
		photo: 'https://i.ibb.co/DwzR0mg/image-0826f544-54d4-4098-8b3a-09314ecc6044-384x384.webp',
	},
	{
		name: 'Nikon Z9',
		price: 5496,
		description: 'Z9 Mirrorless Digital Camera with FTZ II Adapter Kit',
		detailedDescription: `Delivering speed, image quality, and connectivity, the Nikon Z9 is a professional-grade camera characterized by its newly developed sensor, advanced AF performance, and high-resolution 8K video recording. Their first mirrorless flagship camera, the Z9 stands out as a camera that appeals to photographers and filmmakers working across a wide variety of applications.
		`,
		id: 10,
		photo: 'https://i.ibb.co/xCv2Q1m/nikon-z9.webp',
	},
];
export default products;
